module.exports = __webpack_public_path__ + "img/SMT_42_Ms_Koh_Puay_Ling.788e7000.jpg";